import { render, staticRenderFns } from "./DocTraining.vue?vue&type=template&id=2d52a622&scoped=true&"
import script from "./DocTraining.vue?vue&type=script&lang=js&"
export * from "./DocTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52a622",
  null
  
)

export default component.exports